
import { DataModel } from "common/models/utility-models/base-model";


export class InternshipFilterModel extends DataModel {
    selectedBatch = '';
    selectedRegion = '';
    selectedBranch = '';
    selectedState = '';
    searchText = '';
    selectedStatus = '';
    apiResData: any[]
}


